import { ImageThumbnailRatio } from '@components/ImageThumbnailRatio';
import VnrLink from '@components/VnrLink';
import React from 'react';
import { S3_DOMAIN_CONTENT } from 'src/constants';

import styles from './PostItem.module.scss';
export const landingPageUrlList = [
  'phong-van-doc-quyen-ceo-connext',
  'phong-van-giam-doc-fullerton-martkets',
  'phong-van-giam-doc-fxgt-viet-nam',
  'phong-van-doc-quyen-ceo-onebid-tai-viet-nam',
  'phong-van-doc-quyen-giam-doc-dupoin',
  'phong-van-ceo-connext-tai-su-kien-ra-mat-chinh-thuc-cua-connext-tai-viet-nam',
  'phong-van-doc-quyen-ceo-quy-pipfarm'
];
const PostItem = ({ post }) => {
  const { date, title, thumbnail, slug, author } = post;

  const isLandingPage = landingPageUrlList.includes(slug) ? true : false;
  const publicDate = new Date(date);
  const formatDate = new Intl.DateTimeFormat('ru-RU', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(publicDate);

  return (
    <div className={styles.vnrPostItem}>
      <VnrLink
        aria-label={slug}
        to={isLandingPage ? slug : `${slug}.html`}
        className={styles.postThumbnail}
      >
        <ImageThumbnailRatio
          src={
            thumbnail
              ? thumbnail?.replace('https://wp.vnrebates.io/wp-content/', S3_DOMAIN_CONTENT)
              : ''
          }
          alt="post-thumbnail"
        />
      </VnrLink>
      <div className={styles.postInformation}>
        <div>
          <span className={styles.postDetail}>{formatDate}</span>
          {author && (
            <VnrLink to={`/tac-gia/${author.slug}`}>
              <span className={styles.postDetail}>&#8226; {author.name}</span>
            </VnrLink>
          )}
        </div>
        <VnrLink to={isLandingPage ? slug : `${slug}.html`}>
          <h3
            dangerouslySetInnerHTML={{ __html: `${title?.rendered}` }}
            className={styles.postTitle}
          ></h3>
        </VnrLink>
        {/* <div 
          dangerouslySetInnerHTML={{ __html: `${excerpt?.rendered}` }}
          className={styles.postDescription}></div> */}
      </div>
    </div>
  );
};
export default PostItem;
